import { createSlice, createAsyncThunk, createReducer } from "@reduxjs/toolkit";
import {
  EMP_LIST,
  POLICY_LIST,
  ENDORSMENT_LIST,
  EMPLOYER_QUOTE_LIST,
  CLAIM_LIST,
  CD_BAL_LIST,
  EMP_STATUS,
  EMPLOYER_LIST,
  EMPLOYER_ADD,
  EMPLOYER_UPDATE,
  ZONES_LISTS,
  DOCUMENT_BULK_UPLOAD,
  EMPLOYEE_ADD,
  CD_BAL_UPDATE,
  CD_BAL_ADD,
  EMP_CHANGE_STATUS,
} from "../../../../../common/constant";
import { get, post } from "../../../../../common/api";
import Api from "../../../../../common/api/multipart";

//Emp List
export const actionEmpList = createAsyncThunk(
  "listStore/actionEmpList",
  async (params, thunkAPI) => {
    try {
      return await post(EMP_LIST, { ...params, page: 1, size: 1000 }, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);
// Emp status(active inactive) in List
export const actionEmpStatus = createAsyncThunk(
  "listStore/actionEmpStatus",
  async (params, thunkAPI) => {
    try {
      return await post(`${EMP_STATUS}/${params.id}`, params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);
// Policy List
export const actionPolicyList = createAsyncThunk(
  "listStore/actionPolicyList",
  async (params, thunkAPI) => {
    return await post(POLICY_LIST, params, thunkAPI);
  }
);

// Endorsment List
export const actionEndorsmentList = createAsyncThunk(
  "listStore/actionEndorsmentList",
  async (params, thunkAPI) => {
    return await post(ENDORSMENT_LIST, params, thunkAPI);
  }
);

// employer Quote List
export const actionEmployerQuoteList = createAsyncThunk(
  "listStore/actionEmployerQuoteList",
  async (params, thunkAPI) => {
    return await post(EMPLOYER_QUOTE_LIST, params, thunkAPI);
  }
);

// Claim List
export const actionClaimList = createAsyncThunk(
  "listStore/actionClaimList",
  async (params, thunkAPI) => {   
    return await post(`${CLAIM_LIST}${params.dynamic_url}`, params, thunkAPI);
  }
);

// Emp  approved/reject status for on-hold case
export const actionChangeStatus = createAsyncThunk(
  "listStore/actionChangeStatus",
  async (params, thunkAPI) => {
    try {
      return await post(EMP_CHANGE_STATUS, params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

//  CD Balance
export const actionCDBalList = createAsyncThunk(
  "listStore/actionCDBalList",
  async (params, thunkAPI) => {
    return await get(CD_BAL_LIST, params, thunkAPI);
  }
);

// Employer List
export const actionEmployerList = createAsyncThunk(
  "listStore/actionEmployerList",
  async (params, thunkAPI) => {
    return await post(EMPLOYER_LIST, params, thunkAPI);
  }
);

// Employer Add
export const actionEmployerAdd = createAsyncThunk(
  "listStore/actionEmployerAdd",
  async (params, thunkAPI) => {
    try {
      return await post(EMPLOYER_ADD, params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

// Employer Update
export const actionEmployerUpdate = createAsyncThunk(
  "listStore/actionEmployerUpdate",
  async (params, thunkAPI) => {
    try {
      return await post(EMPLOYER_UPDATE, params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

// doc bulk upload

export const actionBulkUpload = createAsyncThunk(
  "listStore/actionBulkUpload",
  async (params, thunkAPI) => {
    try {
      return await Api.multipart(DOCUMENT_BULK_UPLOAD, params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

// zone list

export const actionZoneList = createAsyncThunk(
  "listStore/actionZoneList",
  async (params, thunkAPI) => {
    return await get(ZONES_LISTS, params, thunkAPI);
  }
);

// Employee Add

export const actionEmployeeAdd = createAsyncThunk(
  "listStore/actionEmployeeAdd",
  async (params, thunkAPI) => {
    try {
      return await post(EMPLOYEE_ADD, params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

// cd edit

export const actionCdBalanceUpdate = createAsyncThunk(
  "listStore/actionCdBalanceUpdate",
  async (params, thunkAPI) => {
    try {
      return await Api.multipart(CD_BAL_UPDATE, params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);


export const actionCdBalanceAdd = createAsyncThunk(
  "listStore/actionCdBalanceAdd",
  async (params, thunkAPI) => {
    try {
      return await Api.multipart(CD_BAL_ADD, params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

export const listSlice = createSlice({
  name: "listStore",

  initialState: {
    //Emp List
    loadingEmpList: false,
    EmpList: null,

    //Emp Status List
    loadingEmpStatus: false,
    EmpStatus: null,

    // Policy List
    loadingPolicyList: false,
    PolicyList: null,

    // Endorsment List
    loadingEndorsmentList: false,
    EndorsmentList: null,

    // Employer Quote List
    loadingEmployerQuoteList: false,
    EmployerQuoteList: null,

    // Claim List
    loadingClaimList: false,
    ClaimList: null,

    // CD bal list
    loadingCDBalList: false,
    CDBalList: null,

    // Employer List
    loadingEmployerList: false,
    EmployerList: null,

    // Employer Add
    loadingEmployerAdd: false,
    EmployerAdd: null,

    // Employer Update
    loadingEmployerUpdate: false,
    EmployerUpdate: null,

    // Employer change status
    loadingChangeStatus: false,
    EmployeeChangeStatus: null,

    // Employer Edit
    loadingBulkUpload: false,
    BulkUploadDoc: null,

    // Zone List
    loadingZoneList: false,
    ZoneList: null,

    // Employee Add
    loadingEmployeeAdd: false,
    EmployeeAdd: null,

    // Cd Update
    loadingCdBalanceUpdate: false,
    CdBalanceUpdate: null,

    // Cd Update
    loadingCdBalanceAdd: false,
    CdBalanceAdd: null,
  },

  reducers: {
    //  reset or delete public store data
    // Emp List
    resetEmpList: (state) => {
      state.EmpList = null;
    },

    //Emp Status
    resetEmpStatus: (state) => {
      state.EmpStatus = null;
    },

    //Emp Change Status
    resetChangeStatus: (state) => {
      state.EmployeeChangeStatus = null;
    },

    // Policy List
    resetPolicyList: (state) => {
      state.PolicyList = null;
    },

    // Endorsment List
    resetEndorsmentList: (state) => {
      state.EndorsmentList = null;
    },

    // Employer Quote List
    resetEmployerQuoteList: (state) => {
      state.EmployerQuoteList = null;
    },

    // Claim List
    resetClaimList: (state) => {
      state.ClaimList = null;
    },

    // CD Bal List
    resetCDBalList: (state) => {
      state.CDBalList = null;
    },

    // Employer List
    resetEmployerList: (state) => {
      state.EmployerList = null;
    },

    // Employer Add
    resetEmployerAdd: (state) => {
      state.EmployerAdd = null;
    },

    // Employer Update
    resetEmployerUpdate: (state) => {
      state.EmployerUpdate = null;
    },

    resetDocBulkUpload: (state) => {
      state.BulkUploadDoc = null;
    },

    resetZoneList: (state) => {
      state.ZoneList = null;
    },

    resetEmployeeAdd: (state) => {
      state.EmployeeAdd = null;
    },

    resetCdBalanceUpdate: (state) => {
      state.CdBalanceUpdate = null;
    },

    resetCdBalanceAdd: (state) => {
      state.CdBalanceAdd = null;
    },
  },

  extraReducers: (builder) => {
    builder
      //Emp List
      .addCase(actionEmpList.pending, (state) => {
        state.loadingEmpList = true;
      })
      .addCase(actionEmpList.fulfilled, (state, action) => {
        state.loadingEmpList = true;
        state.EmpList = action.payload;
      })
      .addCase(actionEmpList.rejected, (state) => {
        state.loadingEmpList = false;
      })

      //Emp Status
      .addCase(actionEmpStatus.pending, (state) => {
        state.loadingEmpStatus = true;
      })
      .addCase(actionEmpStatus.fulfilled, (state, action) => {
        state.loadingEmpStatus = true;
        state.EmpStatus = action.payload;
      })
      .addCase(actionEmpStatus.rejected, (state, action) => {
        state.loadingEmpStatus = false;
        state.EmpStatus = { status: false, message: action.payload };
      })

      //Emp  Change Status
      .addCase(actionChangeStatus.pending, (state) => {
        state.loadingChangeStatus = true;
      })
      .addCase(actionChangeStatus.fulfilled, (state, action) => {
        state.loadingChangeStatus = true;
        state.EmployeeChangeStatus = action.payload;
      })
      .addCase(actionChangeStatus.rejected, (state, action) => {
        state.loadingChangeStatus = false;
        state.EmployeeChangeStatus = { status: false, message: action.payload };
      })

      // Policy List
      .addCase(actionPolicyList.pending, (state) => {
        state.loadingPolicyList = true;
      })
      .addCase(actionPolicyList.fulfilled, (state, action) => {
        state.loadingPolicyList = true;
        state.PolicyList = action.payload;
      })
      .addCase(actionPolicyList.rejected, (state) => {
        state.loadingPolicyList = false;
      })

      // Endorsment List
      .addCase(actionEndorsmentList.pending, (state) => {
        state.loadingEndorsmentList = true;
      })
      .addCase(actionEndorsmentList.fulfilled, (state, action) => {
        state.loadingEndorsmentList = true;
        state.EndorsmentList = action.payload;
      })
      .addCase(actionEndorsmentList.rejected, (state) => {
        state.loadingEndorsmentList = false;
      })

      // Employer Quote List
      .addCase(actionEmployerQuoteList.pending, (state) => {
        state.loadingEmployerQuoteList = true;
      })
      .addCase(actionEmployerQuoteList.fulfilled, (state, action) => {
        state.loadingEmployerQuoteList = true;
        state.EmployerQuoteList = action.payload;
      })
      .addCase(actionEmployerQuoteList.rejected, (state) => {
        state.loadingEmployerQuoteList = false;
      })

      // Claim List
      .addCase(actionClaimList.pending, (state) => {
        state.loadingClaimList = true;
      })
      .addCase(actionClaimList.fulfilled, (state, action) => {
        state.loadingClaimList = true;
        state.ClaimList = action.payload;
      })
      .addCase(actionClaimList.rejected, (state) => {
        state.loadingClaimList = false;
      })

      // CD Bal List
      .addCase(actionCDBalList.pending, (state) => {
        state.loadingCDBalList = true;
      })
      .addCase(actionCDBalList.fulfilled, (state, action) => {
        state.loadingCDBalList = true;
        state.CDBalList = action.payload;
      })
      .addCase(actionCDBalList.rejected, (state) => {
        state.loadingCDBalList = false;
      })

      // Employer List
      .addCase(actionEmployerList.pending, (state) => {
        state.loadingEmployerList = true;
      })

      .addCase(actionEmployerList.fulfilled, (state, action) => {
        state.loadingEmployerList = false;
        state.EmployerList = action.payload;
      })

      .addCase(actionEmployerList.rejected, (state) => {
        state.loadingEmployerList = false;
      })

      // Employer Add
      .addCase(actionEmployerAdd.pending, (state) => {
        state.loadingEmployerAdd = true;
      })

      .addCase(actionEmployerAdd.fulfilled, (state, action) => {
        state.loadingEmployerAdd = false;
        state.EmployerAdd = action.payload;
      })

      .addCase(actionEmployerAdd.rejected, (state, action) => {
        state.loadingEmployerAdd = false;
        state.EmployerAdd = { status: false, message: action.payload };
      })

      // Employer Update
        .addCase(actionEmployerUpdate.pending, (state) => {
        state.loadingEmployerUpdate = true;
      })

      .addCase(actionEmployerUpdate.fulfilled, (state, action) => {
        state.loadingEmployerUpdate = false;
        state.EmployerUpdate = action.payload;
      })

      .addCase(actionEmployerUpdate.rejected, (state, action) => {
        state.loadingEmployerUpdate = false;
        state.EmployerUpdate = { status: false, message: action.payload };
      })
      // Bulk Upload
      .addCase(actionBulkUpload.pending, (state) => {
        state.loadingBulkUpload = true;
      })

      .addCase(actionBulkUpload.fulfilled, (state, action) => {
        state.loadingBulkUpload = false;
        state.BulkUploadDoc = action.payload;
      })

      .addCase(actionBulkUpload.rejected, (state, action) => {
        state.loadingBulkUpload = false;
        state.BulkUploadDoc = { status: false, message: action.payload };
      })

      // Zone list
      .addCase(actionZoneList.pending, (state) => {
        state.loadingZoneList = true;
      })
      .addCase(actionZoneList.fulfilled, (state, action) => {
        state.loadingZoneList = false;
        state.ZoneList = action.payload;
      })
      .addCase(actionZoneList.rejected, (state) => {
        state.loadingZoneList = false;
      })

      // Employee Add
      .addCase(actionEmployeeAdd.pending, (state) => {
        state.loadingEmployeeAdd = true;
      })
      .addCase(actionEmployeeAdd.fulfilled, (state, action) => {
        state.loadingEmployeeAdd = false;
        state.EmployeeAdd = action.payload;
      })
      .addCase(actionEmployeeAdd.rejected, (state, action) => {
        state.loadingEmployeeAdd = false;
        state.EmployeeAdd = { status: false, message: action.payload };
      })

      // Cd Update/edit
      .addCase(actionCdBalanceUpdate.pending, (state) => {
        state.loadingCdBalanceUpdate = true;
      })
      .addCase(actionCdBalanceUpdate.fulfilled, (state, action) => {
        state.loadingCdBalanceUpdate = false;
        state.CdBalanceUpdate = action.payload;
      })
      .addCase(actionCdBalanceUpdate.rejected, (state, action) => {
        state.loadingCdBalanceUpdate = false;
        state.CdBalanceUpdate = { status: false, message: action.payload };
      })

      .addCase(actionCdBalanceAdd.pending, (state) => {
        state.loadingCdBalanceAdd = true;
      })
      .addCase(actionCdBalanceAdd.fulfilled, (state, action) => {
        state.loadingCdBalanceAdd = false;
        state.CdBalanceAdd = action.payload;
      })
      .addCase(actionCdBalanceAdd.rejected, (state, action) => {
        state.loadingCdBalanceAdd = false;
        state.CdBalanceAdd = { status: false, message: action.payload };
      });
  },
});

export const {
  resetEmpList,
  resetEmpStatus,
  resetPolicyList,
  resetEndorsmentList,
  resetEmployerQuoteList,
  resetClaimList,
  resetCDBalList,
  resetEmployerList,
  resetEmployerAdd,
  resetEmployerUpdate,
  resetZoneList,
  resetDocBulkUpload,
  resetEmployeeAdd,
  resetCdBalanceUpdate,
  resetCdBalanceAdd,
  resetChangeStatus
} = listSlice.actions;

function parseErrorv1(error) {
  return error?.response?.data?.message;
}

export default listSlice.reducer;
